<template>
  <div class="questionnaire">
    <h3>Complete all questions to submit.</h3>
    <form
      id="form"
      @submit="checkForm"
    >
      <div>
        <h3>Have you been diagnosed with COVID-19 in the past 10 days by a doctor or received a positive lab-based or at-home test result?<span class="required"> *</span></h3>
        <div
          class="error-msg"
          :class="{ error: q0Error}"
        >
          <i class="fad fa-exclamation-circle" /> Please select an option.
        </div>
        <input
          id="q0yes"
          v-model="q0"
          type="radio"
          value="Yes"
        >
        <label
          for="q0yes"
          :class="{ error: q0Error}"
        >Yes</label>
        <br>
        <input
          id="q0no"
          v-model="q0"
          type="radio"
          value="No"
        >
        <label
          for="q0no"
          :class="{ error: q0Error}"
        >No</label>
      </div>
      <div>
        <h3>
          In the last 2 weeks, did you care for or have <a 
            href="https://www.cdc.gov/coronavirus/2019-ncov/php/contact-tracing/contact-tracing-plan/appendix.html#contact" 
            class="external"
          >close contact
          </a> with someone diagnosed with COVID-19?  
          <span class="required"> *</span>
        </h3>
        <div
          class="error-msg"
          :class="{ error: q1Error}"
        >
          <i class="fad fa-exclamation-circle" /> Please select an option.
        </div>
        <input
          id="q1yes"
          v-model="q1"
          type="radio"
          value="Yes"
        >
        <label
          for="q1yes"
          :class="{ error: q1Error}"
        >Yes</label>
        <br>
        <input
          id="q1no"
          v-model="q1"
          type="radio"
          value="No"
        >
        <label
          for="q1no"
          :class="{ error: q1Error}"
        >No</label>
      </div>

      <div>
        <h3>In the past 24 hours have you experienced a <strong>new onset</strong> of any of the following symptoms from an <strong>unknown source</strong>?<span class="required"> *</span></h3>
        <span class="sub-label">Check all that apply.</span>
        <div
          class="error-msg"
          :class="{ error: q3Error}"
        >
          <i class="fad fa-exclamation-circle" /> Please select all options that apply.
        </div>
        <br>
        <input
          id="q3a0"
          v-model="newSymptoms"
          type="checkbox"
          :disabled="!newSymptoms.includes('a0') && newSymptoms.length >= 1"
          value="a0"
          @click="updateNoNewSymptoms"
        >
        <label for="q3a0">No, I'm not experiencing any of these symptoms</label>
        <hr>
        <input
          id="q3a1"
          v-model="newSymptoms"
          type="checkbox"
          value="a1"
          :disabled="noNewSymptoms"
        >
        <label for="q3a1">New or worsening cough</label>

        <input
          id="q3a2"
          v-model="newSymptoms"
          type="checkbox"
          value="a2"
          :disabled="noNewSymptoms"
        >
        <label for="q3a2">Shortness of breath or difficulty breathing</label>

        <input
          id="q3a3"
          v-model="newSymptoms"
          type="checkbox"
          value="a3"
          :disabled="noNewSymptoms"
        >        
        <label for="q3a3">New loss of taste or smell</label>
      </div>

      <div>
        <h3>In the past 24 hours have you experienced a <strong>new onset</strong> of any of the following symptoms from an <strong>unknown source</strong>? <span class="required"> *</span></h3>
        <span class="sub-label">Check all that apply.</span>
        <div
          class="error-msg"
          :class="{ error: q4Error}"
        >
          <i class="fad fa-exclamation-circle" /> Please select all options that apply.
        </div>
        <br>
        <input
          id="q4p0"
          v-model="symptoms"
          type="checkbox"
          :disabled="!symptoms.includes('p0') && symptoms.length >= 1"
          value="p0"
          @click="updateNoSymptoms"
        >
        <label for="q4p0">No, I'm not experiencing any of these symptoms</label>
        <hr>
        <input
          id="q4p1"
          v-model="symptoms"
          type="checkbox"
          :disabled="noSymptoms"
          value="p1"
        >
        <label for="q4p1">Fever</label>
        <input
          id="q4p9"
          v-model="symptoms"
          type="checkbox"
          :disabled="noSymptoms"
          value="p9"
        >
        <label for="q4p9">Chills</label>
        <input
          id="q4p2"
          v-model="symptoms"
          type="checkbox"
          :disabled="noSymptoms"
          value="p2"
        >
        <label for="q4p2">Fatigue</label>
        <input
          id="q4p3"
          v-model="symptoms"
          type="checkbox"
          :disabled="noSymptoms"
          value="p3"
        >
        <label for="q4p3">Muscle or body aches</label>
        <input
          id="q4p4"
          v-model="symptoms"
          type="checkbox"
          :disabled="noSymptoms"
          value="p4"
        >
        <label for="q4p4">Headache</label>
        <input
          id="q4p5"
          v-model="symptoms"
          type="checkbox"
          :disabled="noSymptoms"
          value="p5"
        >
        <label for="q4p5">Sore throat</label>
        <input
          id="q4p6"
          v-model="symptoms"
          type="checkbox"
          :disabled="noSymptoms"
          value="p6"
        >
        <label for="q4p6">Congestion or runny nose</label>
        <input
          id="q4p7"
          v-model="symptoms"
          type="checkbox"
          :disabled="noSymptoms"
          value="p7"
        >
        <label for="q4p7">Nausea or vomiting</label>
        <input
          id="q4p8"
          v-model="symptoms"
          type="checkbox"
          :disabled="noSymptoms"
          value="p8"
        >
        <label for="q4p8">Diarrhea</label>
        <br>
      </div>
      <div>
        <input
          type="submit"
          value="SUBMIT"
          :class="{ incomplete: !(q0 && q1 && symptoms.length != 0 && newSymptoms.length != 0 ) }"
        >
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Questionnaire',
  data: function() {
    return {
      q0: null,
      q1: null,
      q0Error: false,
      q1Error: false,
      q3Error: false,
      q4Error: false,
      symptoms: [],
      newSymptoms: [],
      noSymptoms: false,
      noNewSymptoms: false,
      code: '',
    };
  },
  methods: {
    checkForm: function (e) {
      if (this.q0 && this.q1 && this.newSymptoms.length != 0 && this.symptoms.length != 0) {
        this.getCode();
        this.$router.push({ name: 'Result', params: { code: this.code }});
      }

      if (!this.q0) {
        this.q0Error = true;
      } else {
        this.q0Error = false;
      }
      if (!this.q1) {
        this.q1Error = true;
      } else {
        this.q1Error = false;
      }
      if (this.newSymptoms.length == 0) {
        this.q3Error = true;
      } else {
        this.q3Error = false;
      }
      if (this.symptoms.length == 0) {
        this.q4Error = true;
      } else {
        this.q4Error = false;
      }

      e.preventDefault();
    },
    getCode: function() {
      if ( this.q0 == 'Yes') {
        this.code = 'F1';
        this.loopCodes();
        return;
      } 
      if ( this.symptoms.length >= 2  || (this.newSymptoms.length >= 1 && !(this.newSymptoms.indexOf('a0') >= 0) )){
        this.code = 'D1';
        this.loopCodes();
        return;
      }
      if (this.q1 == 'Yes') {
        this.code = 'E2';
        this.loopCodes();
        return;
      }
      //if no other exceptions, this is your code
      this.code = 'E1';
      this.loopCodes();
      return;
    },
    loopCodes: function(){
      for (let i in this.symptoms) {
        this.code += this.symptoms[i];
      }
      for (let i in this.newSymptoms) {
        this.code += this.newSymptoms[i];
      }
    },
    updateNoSymptoms: function() {
      if(this.symptoms.includes('p0')) {
        this.noSymptoms = false;
      } else {
        this.noSymptoms = true;
        this.symptoms = [ 'p0' ];
      }
    },
    updateNoNewSymptoms: function() {
      if(this.newSymptoms.includes('a0')) {
        this.noNewSymptoms = false;
      } else {
        this.noNewSymptoms = true;
        this.newSymptoms = [ 'a0' ];
      }
    },
    track () {
      this.$gtag.pageview({
        page_path: '/questionnaire',
      });
    },
  },
};
</script>